import { createCustomTheme } from '@domains/subscription/theme'
import { ThemeProvider } from '@mui/material/styles'
import useMaterialNotification from 'hooks/useMaterialNotification'
import { useDisconnectLedger, useLedgerConnection } from '../api/queries'
import { LedgerConnection } from '../usecases/LedgerConnection'

interface LedgerConnectionFactoryProps {
  customerId: string
}

export const LedgerConnectionFactory = ({ customerId }: LedgerConnectionFactoryProps) => {
  const { data: connection, isLoading, isError } = useLedgerConnection(customerId)
  const { mutateAsync: disconnect, isLoading: isDisconnecting } = useDisconnectLedger(customerId)
  const notify = useMaterialNotification()

  const handleDisconnect = () => disconnect().then(() => notify('Accounting system disconnected'))

  return (
    <ThemeProvider theme={createCustomTheme()}>
      <LedgerConnection
        systemName={connection?.systemName}
        isLoading={isLoading}
        isError={isError}
        isDisconnecting={isDisconnecting}
        onDisconnect={handleDisconnect}
      />
    </ThemeProvider>
  )
}
